import React from 'react';
import { test, expect } from '@playwright/experimental-ct-react17';
import { Radio } from './Radio';
import { RadioControlled, RadioGroupControlled } from './Radio.playwright-stories';
import { RadioGroup } from './RadioGroup';

test('radio is checked after click (uncontrolled)', async ({ mount }) => {
  const component = await mount(<Radio label="Test" value="test" />);
  await component.click();
  await expect(component).toBeChecked();
});

test('radio is checked after click (controlled)', async ({ mount }) => {
  const component = await mount(<RadioControlled label="Test" value="test" />);
  await component.click();
  await expect(component).toBeChecked();
});

test('radio group item is checked after click (uncontrolled)', async ({ mount }) => {
  const component = await mount(
    <RadioGroup name="test">
      <Radio label="Example 1" value="example1" />
      <Radio label="Example 2" value="example2" />
      <Radio label="Example 3" value="example3" />
    </RadioGroup>,
  );
  await component.getByText('Example 2').click();
  await expect(component.getByText('Example 2')).toBeChecked();
});

test('radio group item is checked after click (controlled)', async ({ mount }) => {
  const component = await mount(<RadioGroupControlled name="test" />);
  await component.getByText('Example 2').click();
  await expect(component.getByText('Example 2')).toBeChecked();
});

test('onChange is called after selection change', async ({ mount }) => {
  let value: string;
  const component = await mount(
    <RadioGroup
      name="test"
      onChange={(e, v) => {
        value = v;
      }}
    >
      <Radio label="Example 1" value="example1" />
      <Radio label="Example 2" value="example2" />
      <Radio label="Example 3" value="example3" />
    </RadioGroup>,
  );
  await component.getByText('Example 2').click();
  await expect(component.getByText('Example 2')).toBeChecked();
  await expect.poll(() => value).toBe('example2');
});
